// Vendors
import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';

const RefinementList = ({ items, refine, attribute }) => {
  let sortedItems = [...items].sort((a, b) => b.count - a.count); // Sort in descending order

  if (attribute === 'facets.pa_software') {
    sortedItems = [...items].sort((a, b) => {
      const labelA = a.label.toUpperCase();
      const labelB = b.label.toUpperCase();
      return labelA < labelB ? -1 : labelA > labelB ? 1 : 0;
    });
  }

  return sortedItems.map((item) => (
    <div
      className={`facetwp-checkbox${item.isRefined ? ' checked' : ''}`}
      style={{ backgroundColor: item.label }}
      key={item.label}
      onClick={() => refine(item.value)}
    >
      {item.label} <span className="facetwp-counter">({item.count})</span>
    </div>
  ));
};

export default connectRefinementList(RefinementList);
